import type { IconData } from '@stacksjs/iconify-core'

export const toggleOn: IconData = {
  "body": "<circle cx=\"16.5\" cy=\"12\" r=\"2.5\" fill=\"currentColor\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M16.5 6.5h-9a5.5 5.5 0 0 0 0 11h9a5.5 5.5 0 0 0 0-11m0 8a2.5 2.5 0 1 1 0-5a2.5 2.5 0 0 1 0 5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default toggleOn
